import { combineReducers } from 'redux'
import project from '../redux/project/projectReducer'
import auth from '../redux/auth/authReducer'
import meta from '../redux/meta/metaReducer'

export default combineReducers({project, auth, meta})
